import { useQuery } from '@tanstack/react-query';
import {
  searchMeasures,
  getMeasureCategories,
  getPopularMeasures,
  SearchMeasuresParams,
  GroupedMeasures,
  Measure,
} from '../lib/measures';

/**
 * 개선 대책 검색 훅 (자동완성용)
 */
export function useMeasureSearch(
  companyId: string | undefined,
  params: SearchMeasuresParams,
  enabled: boolean = true,
) {
  return useQuery<GroupedMeasures[]>({
    queryKey: ['measures', 'search', companyId, params],
    queryFn: () => searchMeasures(companyId!, params),
    enabled: !!companyId && enabled && (params.search?.length ?? 0) >= 1,
    staleTime: 30 * 1000, // 30초
    placeholderData: (previousData) => previousData,
  });
}

/**
 * 카테고리 목록 조회 훅
 */
export function useMeasureCategories(companyId: string | undefined) {
  return useQuery<string[]>({
    queryKey: ['measures', 'categories', companyId],
    queryFn: () => getMeasureCategories(companyId!),
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000, // 5분
  });
}

/**
 * 인기 대책 조회 훅
 */
export function usePopularMeasures(
  companyId: string | undefined,
  limit: number = 10,
) {
  return useQuery<Measure[]>({
    queryKey: ['measures', 'popular', companyId, limit],
    queryFn: () => getPopularMeasures(companyId!, limit),
    enabled: !!companyId,
    staleTime: 60 * 1000, // 1분
  });
}
